var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.type === "film" ||
    _vm.type === "teleplay" ||
    _vm.type === "cartoon" ||
    _vm.type === "tvshow" ||
    _vm.type === "documentary"
      ? _c(
          "ul",
          { staticClass: "search-class-list-common" },
          [
            _vm._l(_vm.dataList, function (item, index) {
              return _c(
                "li",
                { key: index, staticClass: "search-class-list-li" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "class-item",
                      attrs: {
                        href: item.tiny_url,
                        uigs: _vm.getUigs({ item: item, index: index }),
                        title: item.name,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "search-class-img" },
                        [
                          item.ipad_play_for_list &&
                          item.ipad_play_for_list.fee === "1"
                            ? _c(
                                "div",
                                { staticClass: "fee-logo" },
                                [_c("Logo", { attrs: { title: "vip-film" } })],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("CoverImage", {
                            attrs: { src: item.v_picurl, "is-resize": false },
                          }),
                          _vm._v(" "),
                          item.dockey && item.dockey.indexOf("film") > -1
                            ? _c("div", { staticClass: "search-class-score" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      item.score && item.score.length === 1
                                        ? item.score + ".0"
                                        : item.score
                                    )
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.dockey &&
                          item.dockey.indexOf("tvshow") > -1 &&
                          item.date
                            ? _c("div", { staticClass: "tvshow-date" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(item.date) +
                                    "期\n          "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.dockey &&
                          (item.dockey.indexOf("teleplay") > -1 ||
                            item.dockey.indexOf("film") > -1) &&
                          item.ipad_play_for_list
                            ? _c("div", { staticClass: "teleplay-jishu" }, [
                                parseInt(
                                  item.ipad_play_for_list.episode,
                                  10
                                ) ===
                                parseInt(
                                  item.ipad_play_for_list.finish_episode,
                                  10
                                )
                                  ? _c("span", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            item.ipad_play_for_list
                                              .finish_episode
                                          ) +
                                          "集全\n            "
                                      ),
                                    ])
                                  : parseInt(
                                      item.ipad_play_for_list.episode,
                                      10
                                    )
                                  ? _c("span", [
                                      _vm._v(
                                        "\n              更新至" +
                                          _vm._s(
                                            item.ipad_play_for_list.episode
                                          ) +
                                          "集\n            "
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "search-class-name" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { display: "none" },
                    domProps: { innerHTML: _vm._s("<!--n-->") },
                  }),
                ]
              )
            }),
            _vm._v(" "),
            _vm.dataList.length % 3 === 2
              ? _c("li", { staticClass: "search-class-list-li" })
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showLoading ? _c("div", { staticClass: "loading-result" }) : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }